// https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
import $ from "jquery";
import "slick-carousel";

/* eslint-disable no-console */

// Running Slick slider
$(".wp-block-alfons-ad-cards-list-block-v2").slick({
	infinite: true,
	variableWidth: true,
	slidesToShow: 2,
	centerMode: true,
	arrows: false,

	// the magic
	responsive: [
		{
			breakpoint: 9999,
			settings: "unslick",
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 1,
				dots: true,
			},
		},
	],
});

/* eslint-enable no-console */
